import React, { Component, Fragment ,useState} from "react";
import {
  Row,
  Col,
  Button,
  Select,
  Input,
  Popconfirm,
  Icon,
  Spin,
  Divider,
  Tooltip,
  Alert,
  Checkbox,
  Modal,
  Typography,
  Radio,
  Skeleton,
} from "../common/UIComponents";
import { DriverSelect } from "../components/common/SelectDropdowns/BaseSelect";
import FormButtons from "../components/common/FormButtons";
import {
  fetchDriverPayInfo,
  saveDriverPayInfo,
  deleteDriverPayInfo,
  saveDriverAdjustmentInfo,
  getDriverAdjustmentInfo,
  UpdateDriverAdjustmentInfo,
  deleteDriverAdjustmentInfo,
  getDriverSettlementsForOrder,
  fetchBillingDetails,
} from "../api/Billing";
import userStore from "../stores/UserStore";
import { alertMessage, isEmpty } from "../common/Common";
import _ from "lodash";
import DeleteIcon from "../components/common/DeleteIcon";
import I18n from "../common/I18n";
import { renderAlertMessage } from "../helpers/common";
import EditIcon from "../components/common/EditIcon"
import InvoiceContact from "../components/billing/InvoiceContact";
import InvoicesItemList from "../components/billing/InvoicesItemList";
import DriverAdjustmentsTable from "../components/billing/DriverAdjustmentsTable";
import DriverDailySettlements from "../components/billing/DriverDailySettlements";
import DriverWeeklySettlements from "../components/billing/DriverWeeklySettlements";
import { DriverSettlementApi } from "../api/DriverSettlementApi";
import { saveGrossOrdersData } from "../api/Reports";
import { createDriverRateConfiguration } from "../api/BillingScreenAPI";
import DriverPayConfiguration from "../components/Tasks/DriverPayConfiguration";
import { getOrderTypeIcon } from "../components/orders/OrderTypeIcons";
import { fetchDriverList } from "../api/UsersApi";
import { formatFullName } from "../helpers/common";

const { Text } = Typography;
const { confirm } = Modal;

const OrderCollapsiblePanel = ({
  orderNumber,
  children,
  defaultCollapsed = false,
}) => {
  const [collapsed, setCollapsed] = React.useState(defaultCollapsed);

  return (
    <div
      style={{
        border: "1px solid #dce3ef",
        borderRadius: 8,
        marginBottom: 12,
        overflow: "hidden",
        background: "#fff",
        boxShadow: "0 1px 4px rgba(57,84,132,0.06)",
      }}
    >
      <div
        onClick={() => setCollapsed((c) => !c)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 16px",
          background: collapsed ? "#f7f9fc" : "#eef2fa",
          cursor: "pointer",
          borderBottom: collapsed ? "none" : "1px solid #dce3ef",
          transition: "background 0.2s",
          userSelect: "none",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 28,
              height: 28,
              borderRadius: "50%",
              background: "#395484",
              color: "#fff",
              fontSize: 12,
              fontWeight: 700,
              flexShrink: 0,
            }}
          >
            #
          </span>
          <span
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: "#395484",
              fontStyle: "italic",
              textDecoration: "underline",
            }}
          >
            Order #{orderNumber}
          </span>
        </div>

        {/* Right: chevron */}
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            color: "#395484",
            transition: "transform 0.2s",
            transform: collapsed ? "rotate(0deg)" : "rotate(180deg)",
          }}
        >
          <Icon type="down" style={{ fontSize: 13 }} />
        </span>
      </div>

      {/* Body */}
      {!collapsed && (
        <div style={{ padding: "16px 20px" }}>{children}</div>
      )}
    </div>
  );
};

class BillingDriverPay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inProgress: false,
      isDisplayAdd: false,
      customer_orders: [],
      driver_info: [],
      currentInvoice: this.props.currentInvoice || {},
      orderDriverPayments: [],
      clearDisabled: false,
      // saveDisabled: false,
      driverAdjustments: [],
      driverSettlements: [],
      driverAmounts: [],
      showError: false,
      delivered_driver: false,
      currentInvoiceDriverId: this.props.currentInvoice?.driver_details
        ?.driver_id
        ? this.props.currentInvoice.driver_details.driver_id
        : null,
      decimalPoints: window.localStorage.getItem('round_off_decimals') || 2,
      driverIds: [],
      segregatedDriverPay: {},
      driverPayTypes: {},
      driverPayValues: {},
      allDriverPaymentsByOrder: {},
      drivers: [],
      isFetchingDrivers: false,
    };
  }

  componentDidMount() {
    this.setInitialData();
    this.getdriverAdjustmentInfo();
    this.getDriverSettlements();
    // this.checkButtonDisable();
    this.extractDriverIds();
    this.getDrivers();
  }

  getDrivers = () => {
    const orgId = this.props.userContext?.currentOrg?.id || '';
    this.setState({ isFetchingDrivers: true });

    fetchDriverList({ unscoped: true, orgId, includeWH: false })
      .then((result) => {
        if (result.success && result?.data?.drivers) {
          const orgDrivers = result.data.drivers || [];
          const allDrivers = orgDrivers.map(driver => ({
            id: driver.id,
            employee_code: driver.employee_code,
            full_name: formatFullName(driver),
            deleted_at: driver.deleted_at,
            first_name: driver.first_name,
            last_name: driver.last_name,
          }));
          this.setState({ drivers: allDrivers });
        } else {
          this.setState({ drivers: [] });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({ drivers: [] });
      })
      .finally(() => {
        this.setState({ isFetchingDrivers: false });
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(this.props.currentInvoice, prevProps.currentInvoice)) {
      this.setState(
        {
          currentInvoice: this.props.currentInvoice,
          currentInvoiceDriverId: this.props.currentInvoice?.driver_details
            ?.driver_id
            ? this.props.currentInvoice.driver_details.driver_id
            : null,
        },
        () => {
          this.setInitialData();
          this.extractDriverIds();
        }
      );
    }
  }

  extractDriverIds = () => {
    const { order_driver_details } = this.state.currentInvoice;

    // Check if order_driver_details is available and not empty
    if (!order_driver_details || order_driver_details.length === 0) return;

    // Extract driver IDs from the order_driver_details array
    const driverIds = order_driver_details.flatMap(order =>
      order.driver_details.map(driver => driver.driver_id)
    );

    // Update the state with the driver IDs
    this.setState({ driverIds });
  }

  // checkButtonDisable = () => {
  //   const orderDriverPayments = [...this.state.orderDriverPayments];
  //   let driverIsEmptyCount = 0;
  //   orderDriverPayments.forEach((rec, index) => {
  //     if (rec.driver_payments.length === 0) {
  //       driverIsEmptyCount++;
  //     }
  //   });
  //   if (driverIsEmptyCount === orderDriverPayments.length) {
  //     this.setState({ saveDisabled: true });
  //   } else {
  //     this.setState({ saveDisabled: false });
  //   }
  // };
  handleInvoiceResponse = (result, id) => {
    const defaultInvoice = {
      description: {},
      account_details: {},
      customer_details: {},
      customer_order_id: id,
      remarks: _.get(result, 'remarks', []),
      consolidated_order_numbers: _.get(result, 'consolidated_order_numbers', []),
      is_driver_settlement_approved: result.is_driver_settlement_approved,
      pickup_driver_pay_details: result.pickup_driver_pay_details || {},
      accessorial_charges: [],
      adjustment_charges: [],
      transportation_charges: [],
      order_info: {},
      status: result.billing_status,
      error_log: [],
      error_messages: [],
    };

    const currentInvoice = _.merge({}, defaultInvoice, result.invoice);

    const error_logs = result.error_logs || [];
    currentInvoice.error_log = _.map(_.filter(error_logs, 'error_log'), 'error_log');
    currentInvoice.error_messages = _.map(_.filter(error_logs, 'error_message'), 'error_message');

    return currentInvoice;
  };
  sortPriceList = (data) => {
    const sortedData = _.cloneDeep(data);

    // Sort accessorial charges
    sortedData.accessorial_charges.forEach(charge => {
      charge.price_list = _.sortBy(charge.price_list, 'invoice_name');
    });

    // Sort transportation charges
    // sortedData.transportation_charges.forEach(charge => {
    //   charge.price_list = _.sortBy(charge.price_list, 'invoice_name');
    // });

    // Sort fuel surcharges
    sortedData.fuel_surcharges.forEach(charge => {
      charge.price_list = _.sortBy(charge.price_list, 'invoice_name');
    });

    // Sort adjustment charges
    sortedData.adjustment_charges.forEach(charge => {
      charge.price_list = _.sortBy(charge.price_list, 'invoice_name');
    });

    return sortedData;
  };

    handleDriverPayConfigSaved = (orderId, orderIdentifier) => {
    this.getDriverSettlements();
  };

  getBillingDetails = (id) => {
    this.setState({ isLoading: true });
    fetchBillingDetails(id, this.state.currentOrderGroupType).then((result) => {
      if (result.success) {
        const invoiceStatus = result.billing_status;
        const orgCode = _.get(this.props, 'userContext.currentOrg.code', '');
        const showHoldBucket = _.get(this.props, 'organizationSettings.show_hold_bucket', '') == "true";
        let currentInvoice = this.handleInvoiceResponse(result, id);
        currentInvoice = this.sortPriceList(currentInvoice);
        const defaultTransportationChargeGLCode = result.invoice.transportation_gl_code;
        const transportationCharges = currentInvoice?.transportation_charges?.length ? currentInvoice.transportation_charges[0] : []
        this.setState(
          {
            invoice: currentInvoice,
            inProgress: false,
            consolidatedOrderNumbers: currentInvoice.consolidated_order_numbers,
            isDriverSettlementApproved: currentInvoice.is_driver_settlement_approved,
            is_pickup_by_driver: _.get(currentInvoice, 'pickup_driver_pay_details.is_pickup_by_driver', "false"),
            pickup_order_driver_id: _.get(currentInvoice, 'pickup_driver_pay_details.pickup_order_driver_id', ""),
            pickup_order_amount: _.get(currentInvoice, 'pickup_driver_pay_details.pickup_order_amount', null),
            decimalPoints: window.localStorage.getItem('round_off_decimals') || 2,
            isLoading: false,
            organizationSettings: this.props.organizationSettings,
            showActions: currentInvoice.status === 'READY_FOR_BILLING' ? true : false,
            isInvoiceLocked: currentInvoice?.transportation_charges &&
              currentInvoice.transportation_charges.filter(rec => rec.is_locked == 'true').length > 0 ? true : false,
            isOnHold: showHoldBucket ? invoiceStatus == 'HOLD' : false,
            defaultTransportationChargeGLCode: defaultTransportationChargeGLCode, // Set default GL code
            ikeaChargesrecord:
              this.state.newIkeaChargesRecord?.length > 0
                ? [
                    ...(transportationCharges?.price_list || []),
                    ...this.state.newIkeaChargesRecord,
                  ]
                : transportationCharges?.price_list || [],
          },
          () => {
            if(Object.keys(this.state.rawInvoice).length === 0){
              this.getAccountLos();
            } else{
              // this.setInvoiceLos()
            }
          }
        );
      } else {
        renderAlertMessage(result.errors);
        this.setState({
          invoice: {},
          isLoading: false,
        });
      }
    });
  };

  
  setInitialData = () => {
    const { currentInvoice } = this.state;
    const orderDriverPayments = currentInvoice?.transportation_charges
      ? currentInvoice?.transportation_charges.map((order) => ({
          order_id: order.order_id,
          order_no: order.order_number,
          locations: order.locations || [],
          driver_payments: [
            { driver_id: "", amount: "", amount_type: "ELIGIBLE_PAY", delivered_driver: false },
          ],
          order_type: order.type_of_order,
        }))
      : [];
    this.setState(
      {
        orderDriverPayments,
      },
      () => {
        this.getdriverPayInfo();
        this.extractSegregatedDriverPayFromInvoice();
      }
    );
  };

  extractSegregatedDriverPayFromInvoice = () => {
    const { currentInvoice } = this.state;
    
    if (!currentInvoice?.order_driver_details) return;

    let segregatedDriverPay = {};
    let driverPayTypes = {};
    let driverPayValues = {};

    currentInvoice.order_driver_details.forEach(orderDetail => {
      const { customer_order_id, customer_order_number, driver_details } = orderDetail;
      
      // Check if any driver has segregation enabled (segregate_charges_of is not null)
      const hasSegregation = driver_details.some(driver => 
        driver.driver_rates?.segregate_charges_of !== null && 
        driver.driver_rates?.segregate_charges_of !== undefined &&
        driver.driver_rates?.segregate_charges_of !== ''
      );

      if (hasSegregation) {
        segregatedDriverPay[customer_order_number] = true;

        // Extract segregation settings by segment type
        driver_details.forEach(driver => {
          if (driver.driver_rates && driver.driver_rates.segregate_charges_of) {
            const segmentType = driver.driver_rates.segment_type?.toLowerCase();
            
            if (segmentType === 'pickup' || segmentType === 'delivery') {
              if (driver.driver_rates.segregation_charge_type) {
                driverPayTypes[`${customer_order_number}_${segmentType}`] = 
                  driver.driver_rates.segregation_charge_type.toLowerCase() || 'percentage';
                
                driverPayValues[`${customer_order_number}_${segmentType}`] = 
                  driver.driver_rates.segregation_charge_value || '';
              }
              else if (driver.driver_rates.driver_charge_type) {
                driverPayTypes[`${customer_order_number}_${segmentType}`] = 
                  driver.driver_rates.driver_charge_type.toLowerCase() || 'percentage';
                
                driverPayValues[`${customer_order_number}_${segmentType}`] = 
                  driver.driver_rates.driver_charge_value || '';
              }
            }
          }
        });
      } else {
        // Explicitly set to false when segregate_charges_of is null
        segregatedDriverPay[customer_order_number] = false;
      }
    });

    this.setState({
      segregatedDriverPay,
      driverPayTypes,
      driverPayValues
    });
  };

  getdriverPayInfo = () => {
    const { currentInvoice } = this.state;
    this.setState({ inProgress: true });

    const customer_order_ids = currentInvoice?.transportation_charges?.length > 0 ? currentInvoice.transportation_charges.map(
      (order) => order.order_id
    ) : [];
    fetchDriverPayInfo(customer_order_ids).then((result) => {
      if (result.success) {
        const order_driver_payments = result.order_driver_payments || [];
        this.setDriverPayments(order_driver_payments);
      } else {
        alertMessage(result.errors, "error", 10);
        this.setState({ inProgress: false });
      }
    });
  };


  getdriverAdjustmentInfo = () => {
    const { currentInvoice } = this.state;
    this.setState({ adjProgress: true });
  
    const customer_order_ids = currentInvoice?.transportation_charges?.length > 0 
      ? currentInvoice.transportation_charges.map(order => order.order_id) 
      : [];
  
    getDriverAdjustmentInfo(customer_order_ids).then(result => {
      if (result.success) {
        const driver_pay_adjustments = result.driver_pay_adjustments || [];
        this.setState({
          driverAdjustments: driver_pay_adjustments,
          adjProgress: false
        });
      } else {
        alertMessage(result.errors, "error", 10);
        this.setState({ adjProgress: false });
      }
    });
  };

  getDriverSettlements = () => {
    const { currentInvoice } = this.state;
    this.setState({ settlementProgress: true });

    const orgId = userStore.getStateValue("selectedOrg");
    const customer_order_ids = currentInvoice?.transportation_charges?.length > 0 
      ? currentInvoice.transportation_charges.map(order => order.order_id) 
      : [];

    getDriverSettlementsForOrder(orgId, customer_order_ids).then(result => {
      if(result.success) {
        const driverSettlements = result.settlementReports || []
        const driverAmounts = result.driverAmounts || []
        this.setState({
          driverSettlements,
          driverAmounts,
          settlementProgress: false,
        })
      } else {
        this.setState({settlementProgress: false})
      }
    })
  }

  handleDailySettlementSave = async (records, cb, restoreBackupValue) => {
    const orgId = userStore.getStateValue("selectedOrg");
  
    const isValid = await this.validateBeforeSave(records);
    if (!isValid) {
      records.forEach(record => {
        restoreBackupValue(record.id);
      });
      return;
    }
  
    const payload = {
      organization_id: orgId,
      driver_pay_invoice_lines: records.map(rec => ({
        driver_pay_invoice_line_id: rec.id,
        item_value: rec.item_value,
      })),
    };
  
    try {
      this.setState({settlementProgress: true})
      const result = await DriverSettlementApi.saveOrderLines(payload);
      if (result.success) {
        alertMessage(I18n.t('messages.saved'));
        cb?.();
        this.getDriverSettlements();
        this.setState({settlementProgress: false})
      } else {
        renderAlertMessage(result.errors, 'error', 10);
        this.setState({settlementProgress: false})
      }
    } catch (error) {
      renderAlertMessage(error, 'error', 10);
      this.setState({settlementProgress: false})
    }
  };
  

	validateBeforeSave = (records) => {
		const invalidRecords = records.filter(rec => rec.item_value > rec.eligible_charge);
		if (invalidRecords.length === 0) return Promise.resolve(true);

		return new Promise((resolve) => {
			confirm({
				title: "Settlement Amount is greater than Eligible Amount.",
				content: "Do you want to proceed?",
				okText: "Yes",
				okType: "danger",
				cancelText: "No",
				onOk: () => resolve(true),
				onCancel: () => resolve(false),
			});
		});
	};

  handleWeeklySettlementSave = (data, cb) => {
    const payload = {
      driver_id: data[0].driver_id,
      driver_pay_report_id: data[0].driver_pay_report_id,
      gross_order_reports: data.map((record) =>
        Object.assign(
          {},
          {
            id: record.id,
            gross_revenue: !isEmpty(record.gross_revenue) ? record.gross_revenue : 0.0,
            gross_pay: !isEmpty(record.gross_pay) ? record.gross_pay : 0.0,
          },
        ),
      ),
    }
    this.setState({settlementProgress: true})
    saveGrossOrdersData(payload).then((result) => {
      if (result.success) {
        alertMessage(I18n.t('messages.saved'))
        cb?.();
        this.getDriverSettlements();
        this.setState({settlementProgress: false})
      } else {
        renderAlertMessage(result.errors, 'error', 10)
        this.setState({settlementProgress: false})
      }
    })
  }

  setDriverPayments = (order_driver_payments) => {
    const { orderDriverPayments } = this.state;
    const allDriverPaymentsByOrder = { ...this.state.allDriverPaymentsByOrder };

    if (order_driver_payments.length > 0) {
      order_driver_payments.forEach((rec, index) => {
        const orderIndex = _.findIndex(orderDriverPayments, {
          order_id: rec.customer_order_id,
        });

        const allPayments = rec.driver_payments || [];
        allDriverPaymentsByOrder[rec.customer_order_id] = allPayments;

        const eligiblePayments = allPayments.filter(dp => dp.amount_type !== "FLAT_PAY");
        orderDriverPayments[orderIndex].driver_payments = eligiblePayments.map(dp => {
           return { ...dp, amount_type: dp.amount_type || "ELIGIBLE_PAY" };
        });
        if (orderDriverPayments[orderIndex].driver_payments.length === 0) {
          orderDriverPayments[orderIndex].driver_payments = [
            { driver_id: "", amount: "", amount_type: "ELIGIBLE_PAY", delivered_driver: false },
          ];
        }
        // for setting checkbox to be checked
        const consideredDriver =
          eligiblePayments.findIndex(
            (record, index) =>
              record.driver_id === this.state.currentInvoiceDriverId
          ) >= 0;
        if (consideredDriver > 0) {
          orderDriverPayments[orderIndex].delivered_driver = true;
        }
        //
      });
    } else {
      orderDriverPayments.forEach((rec, index) => {
        orderDriverPayments[index].driver_payments = [
          { driver_id: "", amount: "", amount_type: "ELIGIBLE_PAY", delivered_driver: false },
        ];
      });
    }
    this.setState({
      orderDriverPayments,
      allDriverPaymentsByOrder,
      inProgress: false,
    });
    // this.checkButtonDisable();
  };

  handleDetailsChange = (orderIndex, index, element, value) => {
    const orderDriverPayments = [...this.state.orderDriverPayments];
    orderDriverPayments[orderIndex].driver_payments[index][element] = value;
    this.setState({
      orderDriverPayments,
    });
  };

  // handleRateChange = (orderIndex, rateIndex, value) => {
  //   const orderDriverPayments = [...this.state.orderDriverPayments];
  //   orderDriverPayments[orderIndex].driver_payments[rateIndex].amount = value;
  //   this.setState({ orderDriverPayments });
  // };

  handleSegregatedDriverPayChange = (orderNumber, value) => {
    const wasChecked = this.state.segregatedDriverPay[orderNumber];
    
    this.setState(prevState => ({
      segregatedDriverPay: {
        ...prevState.segregatedDriverPay,
        [orderNumber]: value
      }
    }), () => {
      // If checkbox is being unchecked (was true, now false), auto-save
      if (wasChecked && !value) {
        this.handleSegregatedDriverPayUnsave(orderNumber);
      }
    });
  };

  extractSegregationFromDriverPayConfigs = (configs, orderNumber) => {
  if (!configs || !Array.isArray(configs)) return;

  let newSegregatedDriverPay = {};
  let newDriverPayTypes = {};
  let newDriverPayValues = {};

  configs.forEach((config) => {
    const locationType = config.location_type?.toUpperCase();
    const segment = locationType === "PICKUP" ? "pickup" : locationType === "DELIVERY" ? "delivery" : null;
    if (!segment) return;

    const transportationParam = (config.driver_rate_params || []).find(
      (p) => p.rate_type?.toUpperCase() === "TRANSPORTATION"
    );

    if (transportationParam && transportationParam.segregate_driver_charges === true) {
      newSegregatedDriverPay[orderNumber] = true;

      const chargeType = transportationParam.segregation_charge_type || "percentage";
      const chargeValue = transportationParam.segregation_charge_value ?? "";

      newDriverPayTypes[`${orderNumber}_${segment}`] = chargeType;
      newDriverPayValues[`${orderNumber}_${segment}`] = chargeValue !== null && chargeValue !== undefined ? String(chargeValue) : "";
    }
  });

  if (Object.keys(newSegregatedDriverPay).length > 0) {
    this.setState((prevState) => ({
      segregatedDriverPay: {
        ...prevState.segregatedDriverPay,
        ...newSegregatedDriverPay,
      },
      driverPayTypes: {
        ...prevState.driverPayTypes,
        ...newDriverPayTypes,
      },
      driverPayValues: {
        ...prevState.driverPayValues,
        ...newDriverPayValues,
      },
    }));
  }
};

  handleSegregatedDriverPayUnsave = (orderNumber) => {
    const orderData = this.state.currentInvoice.order_driver_details?.find(
      order => order.customer_order_number === orderNumber
    );
    
    if (!orderData) return;

    const orderInfos = this.state.currentInvoice.orders_info?.filter(
      info => info.order_number === orderNumber
    ) || [];

    const payload = {
      order_id: orderData.customer_order_id,
      segregate_driver_charges: false,
      // segregation_charges: orderInfos.map(info => ({
      //   location_id: info?.locations?.[0]?.location_id || '',
      //   segregatation_type: info.segment_type?.toLowerCase(),
      //   segregation_charge_value: 0,
      // }))      
    };
    this.setState({ inProgress: true });
    createDriverRateConfiguration(payload).then((result) => {
      if (result.success) {
        alertMessage(result.message);
        this.setState({ inProgress: false });
        this.getDriverSettlements();
      } else {
        alertMessage(result.message, "error", 10);
        this.setState({ inProgress: false });
      }
    });
  };


  handleDriverPayConfigsLoaded = (configs, orderNumber) => {
    this.extractSegregationFromDriverPayConfigs(configs, orderNumber);
  };

  getCalculatedDriverPay(orderNumber, type) {
    const payType = this.state.driverPayTypes[`${orderNumber}_${type}`] || 'percentage';
    const value = parseFloat(this.state.driverPayValues[`${orderNumber}_${type}`]) || 0;

    // Determine which driver pay amount to use based on the segregation type
    const orderData = this.state.currentInvoice.order_driver_details?.find(
      order => order.customer_order_number === orderNumber
    );
    
    if (!orderData) return '0.00';

    const orderInfos = this.state.currentInvoice.orders_info?.filter(
      info => info.order_number === orderNumber
    ) || [];

    // For transfer orders, use segment_type; for non-transfer orders, use type_of_order
    const pickupLeg = orderInfos.find(info => info.segment_type === 'PICKUP');
    const deliveryLeg = orderInfos.find(info => info.segment_type === 'DELIVERY');
    
    // If no segment_type found, it's a non-transfer order
    const isTransferOrder = pickupLeg || deliveryLeg;
    
    let pickupAmount = 0;
    let deliveryAmount = 0;
    
    if (isTransferOrder) {
      pickupAmount = this.state.driverAmounts.find(d => d.segment === 'PICKUP' && d.order_id === orderData.customer_order_id)?.amount || 0;
      deliveryAmount = this.state.driverAmounts.find(d => d.segment === 'DELIVERY' && d.order_id === orderData.customer_order_id)?.amount || 0;
    } else {
      const orderInfo = orderInfos[0];
      if (orderInfo?.type_of_order === 'R') {
        pickupAmount = this.state.driverAmounts.find(d => d.segment === 'PICKUP' && d.order_id === orderData.customer_order_id)?.amount || 0;
      } else if (orderInfo?.type_of_order === 'D') {
        deliveryAmount = this.state.driverAmounts.find(d => d.segment === 'DELIVERY' && d.order_id === orderData.customer_order_id)?.amount || 0;
      }
    }
    
    const baseAmount = pickupAmount + deliveryAmount;

    if (payType === 'flat') {
      return value.toFixed(2);
    }

    if (payType === 'percentage') {
      return ((baseAmount * value) / 100).toFixed(2);
    }

    return '0.00';
  }


  handleDriverPayTypeChange = (orderNumber, leg, value) => {
    this.setState(prevState => ({
      driverPayTypes: {
        ...prevState.driverPayTypes,
        [`${orderNumber}_${leg}`]: value
      },
      driverPayValues: {
        ...prevState.driverPayValues,
        [`${orderNumber}_${leg}`]: ''
      }
    }));
  };

_computeBaseAmount = (orderData, orderInfos, driverAmounts) => {
  const is_segregated_pay = orderInfos.some(info => info.segment_type);
  let pickupAmount = 0;
  let deliveryAmount = 0;

  if (is_segregated_pay) {
    pickupAmount = driverAmounts.find(
      d => d.segment === 'PICKUP' && d.order_id === orderData.customer_order_id
    )?.amount || 0;

    deliveryAmount = driverAmounts.find(
      d => d.segment === 'DELIVERY' && d.order_id === orderData.customer_order_id
    )?.amount || 0;
  } else {
    const orderInfo = orderInfos[0];
    if (orderInfo?.type_of_order === 'R') {
      pickupAmount = driverAmounts.find(
        d => d.segment === 'PICKUP' && d.order_id === orderData.customer_order_id
      )?.amount || 0;
    } else if (orderInfo?.type_of_order === 'D') {
      deliveryAmount = driverAmounts.find(
        d => d.segment === 'DELIVERY' && d.order_id === orderData.customer_order_id
      )?.amount || 0;
    }
  }

  return pickupAmount + deliveryAmount;
};

_clampValue = (value, payType, baseAmount) => {
  let final = value;
  if (payType === 'percentage') {
    if (Number(value) < 0) final = '0';
    else if (Number(value) > 100) final = '100';
  } else if (payType === 'flat') {
    if (Number(value) < 0) final = '0';
    else if (Number(value) > baseAmount) final = baseAmount.toString();
  }
  return final;
};


  handleDriverPayValueChange = (orderNumber, leg, value) => {
    const key = `${orderNumber}_${leg}`;
    const payType = this.state.driverPayTypes[key] || 'percentage';

    if (value !== '' && !/^\d*\.?\d*$/.test(value)) {
      return;
    }

    let finalValue = value;

    const orderData = this.state.currentInvoice.order_driver_details?.find(
      order => order.customer_order_number === orderNumber
    );
    
    if (!orderData) return;

    const orderInfos = this.state.currentInvoice.orders_info?.filter(
      info => info.order_number === orderNumber
    ) || [];

  const baseAmount = this._computeBaseAmount(orderData, orderInfos, this.state.driverAmounts);

    if (value !== '') {
    finalValue = this._clampValue(value, payType, baseAmount);

      const otherLeg = leg === 'pickup' ? 'delivery' : 'pickup';
      const otherKey = `${orderNumber}_${otherLeg}`;
      const otherPayType = this.state.driverPayTypes[otherKey] || 'percentage';
      const otherValue = parseFloat(this.state.driverPayValues[otherKey]) || 0;

      let currentAmount = payType === 'percentage' ? (baseAmount * parseFloat(finalValue)) / 100 : parseFloat(finalValue);

    let otherAmount = otherPayType === 'percentage'  ? (baseAmount * otherValue) / 100  : otherValue;

      const totalAmount = currentAmount + otherAmount;
      if (totalAmount > baseAmount && baseAmount > 0) {
        const maxAllowedForCurrent = baseAmount - otherAmount;

        if (payType === 'percentage') {
          const maxPercentage = Math.max(0, (maxAllowedForCurrent / baseAmount) * 100);
          finalValue = maxPercentage.toFixed(2);
        } else {
          finalValue = Math.max(0, maxAllowedForCurrent).toFixed(2);
        }
      }
    }

    this.setState(prevState => ({
      driverPayValues: {
        ...prevState.driverPayValues,
        [key]: finalValue
      }
    }));
  };


  handleSegregatedDriverPaySave = (orderId) => {
    const { driverPayTypes, driverPayValues } = this.state;

    const orderData = this.state.currentInvoice.order_driver_details?.find(
      order => order.customer_order_id === orderId
    );
    if (!orderData) return;
    const orderNumber = orderData?.customer_order_number;

    const orderInfos = this.state.currentInvoice.orders_info?.filter(
      info => info.order_number === orderNumber
    ) || [];
    
    const isTransferOrder = orderInfos.some(info => info.segment_type);
    
    let pickupAmount = 0;
    let deliveryAmount = 0;
    let segregate_charges_on = '';
    
    if (isTransferOrder) {
      const pickupLeg = orderInfos.find(info => info.segment_type === 'PICKUP');
      const deliveryLeg = orderInfos.find(info => info.segment_type === 'DELIVERY');

      pickupAmount =
        this.state.driverAmounts.find(
          d => d.segment === 'PICKUP' && d.order_id === orderId
        )?.amount || 0;

      deliveryAmount =
        this.state.driverAmounts.find(
          d => d.segment === 'DELIVERY' && d.order_id === orderId
        )?.amount || 0;

      if (pickupLeg?.level_of_service === 'NONE') {
        // If pickup is NONE, use delivery location_id
        segregate_charges_on = deliveryLeg?.locations?.[0]?.location_id || '';
      } else if (deliveryLeg?.level_of_service === 'NONE') {
        // If delivery is NONE, use pickup location_id
        segregate_charges_on = pickupLeg?.locations?.[0]?.location_id || '';
      }
    } else {
      const orderInfo = orderInfos[0];

      if (orderInfo?.type_of_order === 'R') {
        pickupAmount =
          this.state.driverAmounts.find(
            d => d.segment === 'PICKUP' && d.order_id === orderId
          )?.amount || 0;
        deliveryAmount = 0;
      } else if (orderInfo?.type_of_order === 'D') {
        pickupAmount = 0;
        deliveryAmount =
          this.state.driverAmounts.find(
            d => d.segment === 'DELIVERY' && d.order_id === orderId
          )?.amount || 0;
      }

      segregate_charges_on = orderInfo?.locations?.[0]?.location_id || '';
    }

    const baseAmount = pickupAmount + deliveryAmount;

    const pickupPayType = driverPayTypes[`${orderNumber}_pickup`] || 'percentage';
    const pickupValue = parseFloat(driverPayValues[`${orderNumber}_pickup`]) || 0;
    const deliveryPayType = driverPayTypes[`${orderNumber}_delivery`] || 'percentage';
    const deliveryValue = parseFloat(driverPayValues[`${orderNumber}_delivery`]) || 0;

    let pickupAmountInDollars = 0;
    let deliveryAmountInDollars = 0;

    if (pickupPayType === 'percentage') {
      pickupAmountInDollars = (baseAmount * pickupValue) / 100;
    } else {
      pickupAmountInDollars = pickupValue;
    }

    if (deliveryPayType === 'percentage') {
      deliveryAmountInDollars = (baseAmount * deliveryValue) / 100;
    } else {
      deliveryAmountInDollars = deliveryValue;
    }

    const totalAmount = pickupAmountInDollars + deliveryAmountInDollars;
    const tolerance = 0.01;

    if (Math.abs(totalAmount - baseAmount) > tolerance) {
      const missingAmount = baseAmount - totalAmount;
      if (missingAmount > 0) {
        alertMessage(
          `Total allocation ($${totalAmount.toFixed(
            2
          )}) is less than the required amount ($${baseAmount.toFixed(
            2
          )}). Missing: $${missingAmount.toFixed(2)}`,
          "error",
          10
        );
      } else {
        alertMessage(
          `Total allocation ($${totalAmount.toFixed(
            2
          )}) exceeds the maximum amount ($${baseAmount.toFixed(
            2
          )}). Excess: $${Math.abs(missingAmount).toFixed(2)}`,
          "error",
          10
        );
      }
      return;
    }

    const segregate_driver_charges = true;
    const segregation_charges = [];

    orderInfos.forEach(info => {
      const segment = info.segment_type?.toLowerCase();
      const value = Number(this.state.driverPayValues[`${orderNumber}_${segment}`] || 0);
      const chargeType = this.state.driverPayTypes[`${orderNumber}_${segment}`] || 'percentage';
    
      (info.locations || []).forEach(loc => {
        segregation_charges.push({
          location_id: loc.location_id,
          segregatation_type: segment,
          segregation_charge_value: value,
          segregate_driver_charges: true,
          segregation_charge_type: chargeType
        });
      });
    });
    

    const payload = {
      order_id: orderId,  
      segregation_charges,
      segregate_charges_on,
      segregate_driver_charges
    };

    this.setState({ inProgress: true });
    createDriverRateConfiguration(payload).then((result) => {
      if (result.success) {
        alertMessage(result.message);
        this.getDriverSettlements();
        this.setState({ inProgress: false });
      } else {
        alertMessage(result.message, "error", 10);
        this.setState({ inProgress: false });
      }
    });
  };

  handleSave = () => {
    const orderDriverPayments = [...this.state.orderDriverPayments];
    let fieldIsEmptyCount = 0;
    orderDriverPayments.forEach((rec, index) => {
      const driverEmpty =
        rec.driver_payments.findIndex(
          (record, index) =>
            (!isEmpty(record.driver_id) && isEmpty(record.amount)) ||
            (isEmpty(record.driver_id) && !isEmpty(record.amount))
        ) >= 0;

      if (driverEmpty) {
        fieldIsEmptyCount++;
      }
    });
    if (fieldIsEmptyCount > 0) {
      this.setState({
        showError: true,
      });
    } else {
      this.setState({ inProgress: true });
      const customerOrders = [];
      this.state.orderDriverPayments.forEach((order) => {
        // const { ["order_no"]: deletedKey, ...rest } = order;
        const { order_no, delivered_driver, ...rest } = order;
        if (rest?.driver_payments.length > 0) {
          const orderDriverPayments = rest.driver_payments.filter(
            (rec) => !isEmpty(rec.driver_id) && !isEmpty(rec.amount)
          );
          if (orderDriverPayments.length > 0) {
            const orderInfos = this.state.currentInvoice.orders_info?.filter(
              info => info.order_number === order.order_no
            ) || [];
            const pickupLeg = orderInfos.find(info => info.segment_type === 'PICKUP');
            const deliveryLeg = orderInfos.find(info => info.segment_type === 'DELIVERY');

            let locationId = '';
            if (pickupLeg?.level_of_service === 'NONE') {
              locationId = deliveryLeg?.locations?.[0]?.location_id || '';
            } else if (deliveryLeg?.level_of_service === 'NONE') {
              locationId = pickupLeg?.locations?.[0]?.location_id || '';
            }

            customerOrders.push({
              ...rest,
              driver_payments: [...orderDriverPayments].map(dp => ({ ...dp, amount_type: dp.amount_type !== 'FLAT_PAY' ? (dp.amount_type || 'ELIGIBLE_PAY') : 'ELIGIBLE_PAY' })),
              segregate_driver_charges: this.state.segregatedDriverPay[order.order_no] ? 'true' : 'false',
              pickup_segregation_charge_type: this.state.driverPayTypes[`${order.order_no}_pickup`] || 'percentage',
              pickup_segregation_charge_value: this.state.driverPayValues[`${order.order_no}_pickup`] || '',
              delivery_segregation_charge_type: this.state.driverPayTypes[`${order.order_no}_delivery`] || 'percentage',
              delivery_segregation_charge_value: this.state.driverPayValues[`${order.order_no}_delivery`] || '',
              location_id: locationId
            });
          }
        }
      });
      const data = {
        customer_orders: customerOrders,
        customer_order_ids:
          this.state.currentInvoice?.transportation_charges.map(
            (order) => order.order_id
          ),
        account_id: this.state.currentInvoice.account_details.id,
        organization_id: userStore.getStateValue("selectedOrg"),
        screen_from : "BILLING"
      };

      saveDriverPayInfo(data).then((result) => {
        if (result.success) {
          alertMessage("Saved Successfully");
          this.setState(
            {
              inProgress: false,
              showError: false,
              // saveDisabled: false,
            },
            () => {
              this.setInitialData();
            }
          );
        } else {
          alertMessage(result.errors, "error", 10);
          this.setState({ inProgress: false });
        }
      });
    }
  };

  buildDriverPayDeletePayload = (orders = [], screenFrom = "BILLING") => ({
    screen_from: screenFrom,
    customer_orders: orders.map((order) => ({
      order_id: order.order_id,
      order_number: order.order_no || order.order_number,
      driver_payments: (order.driver_payments || [])
        .filter((dp) => !isEmpty(dp.driver_id) && !isEmpty(dp.amount))
        .map((dp) => ({
          driver_id: dp.driver_id,
          amount: dp.amount,
          amount_type: dp.amount_type || "ELIGIBLE_PAY",
          delivered_driver: !!dp.delivered_driver,
        })),
    })),
  });

  handleClear = () => {
    const { orderDriverPayments } = this.state;
    this.setState({ inProgress: true });
    const customer_order_ids = orderDriverPayments.map(
      (order) => order.order_id
    );
    const payload = this.buildDriverPayDeletePayload(orderDriverPayments, "BILLING");
    deleteDriverPayInfo(customer_order_ids, payload).then((result) => {
      if (result.success) {
        alertMessage(result.message, "success", 10);
        this.setState({ showError: false });
        this.setDriverPayments([]);
        this.clearCheckboxes();
      } else {
        renderAlertMessage(result.errors)
        this.setState({ inProgress: false });
      }
    });
  };

  clearCheckboxes = () => {
    const orderDriverPayments = [...this.state.orderDriverPayments];
    orderDriverPayments.forEach((record) => {
      record.delivered_driver = false;
    });
    this.setState({ orderDriverPayments });
  };

  handleCheckedChange = (orderIndex, element, value) => {
    const orderDriverPayments = [...this.state.orderDriverPayments];
    orderDriverPayments[orderIndex][element] = value;
    this.setState({ orderDriverPayments }, () => {
      orderDriverPayments.forEach((order, index) => {
        if (orderIndex === index) {
          if (order.delivered_driver && order.delivered_driver === true) {
            if (order.driver_payments.length > 0) {
              if (
                isEmpty(order.driver_payments[0].driver_id) &&
                isEmpty(order.driver_payments[0].amount)
              ) {
                order.driver_payments[0].driver_id =
                  this.state.currentInvoiceDriverId;
                order.driver_payments[0].amount = "";
                order.driver_payments[0].amount_type = "ELIGIBLE_PAY";
                order.driver_payments[0].delivered_driver = true;
              } else {
                order.driver_payments.unshift({
                  driver_id: this.state.currentInvoiceDriverId,
                  amount: "",
                  amount_type: "ELIGIBLE_PAY",
                  delivered_driver: true,
                });
              }
            } else {
              order.driver_payments.push({
                driver_id: this.state.currentInvoiceDriverId,
                amount: "",
                amount_type: "ELIGIBLE_PAY",
                delivered_driver: true,
              });
            }
          } else if (order.delivered_driver === false) {
            order.driver_payments = order.driver_payments.filter(
              (order) => order.driver_id !== this.state.currentInvoiceDriverId
            );
          }
        }
      });

      this.setState({ orderDriverPayments });
    });
  };

  addDriverPayRow = (orderIndex) => {
    const orderDriverPayments = [...this.state.orderDriverPayments];
    orderDriverPayments[orderIndex].driver_payments.push({
      driver_id: "",
      amount: "",
      amount_type: "ELIGIBLE_PAY",
    });
    this.setState({
      orderDriverPayments,
    });
    // this.checkButtonDisable();
  };

  removeDriverPayRow = (orderIndex, rowIndex) => {
    const orderDriverPayments = [...this.state.orderDriverPayments];
    if (
      orderDriverPayments.length > 0 &&
      orderDriverPayments[orderIndex].driver_payments.length > 0 &&
      orderIndex >= 0
    ) {
      orderDriverPayments[orderIndex].driver_payments.splice(rowIndex, 1);

      this.setState({
        orderDriverPayments,
        showError: false,
      });
    }
    // this.checkButtonDisable();
  };

  handleDeleteDriverPayRow = (orderIndex, rowIndex) => {
    const order = this.state.orderDriverPayments?.[orderIndex];
    const deletedRow = order?.driver_payments?.[rowIndex];

    if (!order || !deletedRow || isEmpty(deletedRow.driver_id) || isEmpty(deletedRow.amount)) {
      this.removeDriverPayRow(orderIndex, rowIndex);
      return;
    }

    const existingRowsForOrder = this.state.allDriverPaymentsByOrder?.[order.order_id] || [];
    const isPersistedRow = existingRowsForOrder.some((row) => {
      return (
        String(row.driver_id) === String(deletedRow.driver_id) &&
        String(row.amount_type || "ELIGIBLE_PAY") === String(deletedRow.amount_type || "ELIGIBLE_PAY") &&
        Number(row.amount) === Number(deletedRow.amount)
      );
    });

    if (!isPersistedRow) {
      this.removeDriverPayRow(orderIndex, rowIndex);
      return;
    }

    const customer_order_ids = [order.order_id];
    const payload = this.buildDriverPayDeletePayload([
      {
        order_id: order.order_id,
        order_no: order.order_no,
        driver_payments: [deletedRow],
      },
    ], "BILLING");

    this.setState({ inProgress: true });
    deleteDriverPayInfo(customer_order_ids, payload).then((result) => {
      if (result.success) {
        this.removeDriverPayRow(orderIndex, rowIndex);
        this.setState({ inProgress: false });
      } else {
        renderAlertMessage(result.errors);
        this.setState({ inProgress: false });
      }
    });
  };

  // onDriverPaySave = (record, order) => {
  //     const data = {
  //       customer_order_id: order.order_id,
  //         driver_adjustments: {
  //         gl_code: record.glCode,
  //         description: record.description,
  //         amount: record.amount,
  //         location_id: record.orderType
  //       },
  //       account_id: this.state.currentInvoice.account_details.id,
  //       organization_id: userStore.getStateValue("selectedOrg"),
  //     };
  //     this.setState({
  //       inProgress: true
  //     })

  //     saveDriverAdjustmentInfo(data).then((result) => {
  //       if (result.success) {
  //         alertMessage("Saved Successfully");
  //         this.setState(
  //           {
  //             inProgress: false,
  //           }
  //         );
  //       } else {
  //         alertMessage(result.errors[0], "error", 10);
  //         this.setState({ inProgress: false });
  //       }
  //     });
  // };

  onDriverPaySave = (record, order) => {
    const data = {
      customer_order_id: order.order_id,
      driver_adjustments: {
        gl_code: record.glCode, // Ensure keys are correctly mapped
        description: record.description,
        amount: record.amount,
        location_id: record.location_id,
        amount_type: record.amount_type
      },
      account_id: this.state.currentInvoice.account_details.id,
      organization_id: userStore.getStateValue("selectedOrg"),
    };
    if(!record.isNew){
      data.id = record.key;
    }
  
    console.log('Payload Data:', data);  // Log the final payload data
  
    this.setState({ adjProgress: true });
  
    saveDriverAdjustmentInfo(data).then((result) => {
      if (result.success) {
        alertMessage("Saved Successfully");
        this.getdriverAdjustmentInfo();
      } else {
        alertMessage(result.errors[0], "error", 10);
        this.setState({ adjProgress: false });
      }
    });
  };
  
  onDriverPayDelete = (id) => {
    const organization_id =  userStore.getStateValue("selectedOrg");  
    this.setState({ adjProgress: true });
    deleteDriverAdjustmentInfo(id, organization_id ).then((result) => {
      if (result.success) {
        alertMessage(result.message || "Deleted Successfully");
        this.setState({ 
          adjProgress: false, 
          driverAdjustments: this.state.driverAdjustments.filter(adj => adj.id !== id) 
        });
      } else {
        renderAlertMessage(result.errors[0], "error", 10);
        this.setState({ adjProgress: false });
      }
    });
  };

  renderSectionHeader = (title) => (
    <Row style={{ marginBottom: 12 }}>
      <Col xs={24} className="alignLeft">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <div
            style={{
              width: 4,
              height: 20,
              background: "#395484",
              borderRadius: 2,
              flexShrink: 0,
            }}
          />
          <span
            style={{
              fontSize: 15,
              fontWeight: 700,
              color: "#395484",
              letterSpacing: 0.2,
            }}
          >
            {title}
          </span>
        </div>
      </Col>
    </Row>
  );

  render() {
    const { orderDriverPayments, currentInvoice } = this.state;
    console.log(orderDriverPayments);
    const { isLocked } = this.props;
    const { drivers } = this.state;
    const filteredDrivers = drivers.filter(
      (driver) => !this.state.driverIds.includes(driver.id) && !driver.deleted_at
    );
    const { inProgress, currentInvoiceDriverId } = this.state;
    // Helper to get available drivers for a specific row
    const getAvailableDrivers = (order, currentRowIndex) => {
      const selectedDriverIdsInOtherRows = order.driver_payments
        .filter((dp, index) => index !== currentRowIndex && !isEmpty(dp.driver_id))
        .map((dp) => dp.driver_id);

      const flatPayDriverIds = (this.state.allDriverPaymentsByOrder[order.order_id] || [])
        .filter((dp) => dp.amount_type === "FLAT_PAY")
        .map((dp) => dp.driver_id);

      const available = filteredDrivers.filter((driver) => !selectedDriverIdsInOtherRows.includes(driver.id) && !flatPayDriverIds.includes(driver.id));

      // If the current row has a selected driver who is deleted (not in filteredDrivers),
      // inject them back so the Select can display their info
      const currentRowDriverId = order.driver_payments[currentRowIndex]?.driver_id;
      if (currentRowDriverId) {
        const alreadyIncluded = available.some((d) => d.id === currentRowDriverId);
        if (!alreadyIncluded) {
          const deletedDriver = drivers.find((d) => d.id === currentRowDriverId);
          if (deletedDriver) {
            return [deletedDriver, ...available];
          }
        }
      }

      return available;
    };
    const isDisabled = isLocked; // isLocked || this.state.currentInvoice.status === "APPROVED";
    const driverSettlementsBy = _.get(this.props, 'userContext.orgRules.org_billing_rules.display_driver_set_reports_by', 'weekly');
    const driverRateSheetEnabled = _.get(this.props, 'userContext.orgRules.org_billing_rules.ds_rate_sheet_config', 'false');
    return (
      <div className="content" data-testid="driver-pay-tab">
        {/* Section 1: Pickup Driver Pays */}
        {this.renderSectionHeader("Pickup Driver Pays")}
        <div className="config-header-row">
          <p className="note-message" >
            <sup style={{ color: "red", fontSize: 22, top: 3 }}>*</sup>{" "}
            <strong>Note:</strong> {"Payments added here process as Eligible Pay against charges. For Fixed/Flat Pay, use the Order screen."}
          </p>
        </div>
        {this.state.inProgress ? (
          <Skeleton active paragraph={{ rows: 4 }} />
        ) : (
          <>
            {orderDriverPayments.map((order, orderIndex) => (
              <Fragment key={`pickupDriverPays${orderIndex}`}>
                <Row>
                  <Col xs={12} className="alignLeft">
                    <span
                      style={{
                        fontSize: 14,
                        fontStyle: "italic",
                        fontWeight: "bold",
                        textDecoration: "underline",
                        color: "#395484",
                      }}
                    >
                      For Order #{order.order_no}
                    </span>
                  </Col>
                </Row>
    
                {orderDriverPayments &&
                orderDriverPayments[orderIndex].driver_payments.length > 0 ? (
                  <Fragment>
                    <Row className="marginTop10" gutter={32}>
                      <Col xs={24}>
                        <Col xs={8}>
                          <span style={{ fontWeight: 700 }}>
                            <sup style={{ color: "red" }}>*</sup>
                            {I18n.t("general.driver")}:
                          </span>
                        </Col>
                        <Col xs={8}>
                          <span style={{ fontWeight: 700 }}>
                            <sup style={{ color: "red" }}>*</sup>
                            {I18n.t("account.billing.order_amount")}:
                          </span>
                        </Col>
                      </Col>
                    </Row>
    
                    {orderDriverPayments[orderIndex].driver_payments.map(
                      (driverInfoRow, index) => {
                        const isRowModified =
                          (!isEmpty(driverInfoRow.driver_id) &&
                            isEmpty(driverInfoRow.amount)) ||
                          (isEmpty(driverInfoRow.driver_id) &&
                            !isEmpty(driverInfoRow.amount));
    
                        return (
                          <Row
                            className="marginTop10"
                            key={`orderRow${order.orderIndex}${index}`}
                            gutter={8}
                            type="flex"
                          >
                            <Col xs={24} style={{ marginBottom: 6 }}>
                              <Col xs={8}>
                                <Select
                                  data-testid={`driver-input-${index}`}
                                  showSearch
                                  value={driverInfoRow.driver_id || ""}
                                  onChange={(e) =>
                                    this.handleDetailsChange(
                                      orderIndex,
                                      index,
                                      "driver_id",
                                      e
                                    )
                                  }
                                  filterOption={(input, option) => {
                                    const children = option.props.children;
                                    if (children && children.length > 0) {
                                      if (Array.isArray(children)) {
                                        return children[0]
                                          .toLowerCase()
                                          .indexOf(input.toLowerCase()) >= 0;
                                      } else {
                                        return children
                                          .toLowerCase()
                                          .indexOf(input.toLowerCase()) >= 0;
                                      }
                                    }
                                  }}
                                  style={{ width: "80%", height: "20%" }}
                                  disabled={
                                    driverInfoRow.driver_id ===
                                    this.state.currentInvoiceDriverId
                                  }
                                >
                                  {!this.state.driverIds.includes(driverInfoRow.driver_id)
                                    ? getAvailableDrivers(order, index).map((driver) => (
                                        <Select.Option
                                          key={driver.employee_code}
                                          value={driver.id}
                                        >
                                          {driver.employee_code}
                                        {driver.deleted_at ? (
                                          <span style={{ color: "#ff4d4f", fontSize: 11, marginLeft: 6 }}>
                                            (Deleted)
                                          </span>
                                        ) : null}
                                        </Select.Option>
                                      ))
                                    : this.state.drivers.filter((d) => !d.deleted_at).map((driver) => (
                                        <Select.Option
                                          key={driver.employee_code}
                                          value={driver.id}
                                        >
                                          {driver.employee_code}
                                        </Select.Option>
                                      ))}
                                </Select>
                                <Col>
                                  {isRowModified &&
                                    isEmpty(driverInfoRow.driver_id) &&
                                    this.state.showError && (
                                      <span className="textRed font500 marginTop5">
                                        {"Please Select!"}
                                      </span>
                                    )}
                                </Col>
                              </Col>
                              <Col xs={8}>
                                <Input
                                  data-testid={`amount-input-${index}`}
                                  type="number"
                                  value={driverInfoRow.amount}
                                  onChange={(e) =>
                                    this.handleDetailsChange(
                                      orderIndex,
                                      index,
                                      "amount",
                                      e.target.value
                                    )
                                  }
                                  min={0}
                                  precision={this.state.decimalPoints}
                                  defaultValue={0}
                                  style={{ width: "80%", height: "20%" }}
                                />
                                <Col>
                                  {isRowModified &&
                                    isEmpty(driverInfoRow.amount) &&
                                    this.state.showError && (
                                      <span className="textRed font500 marginTop5">
                                        {"Please Select!"}
                                      </span>
                                    )}
                                </Col>
                              </Col>
                              <Col xs={8}>
                              <Row gutter={16} type="flex">
                                <Col>
                                     {!isDisabled &&
                                  !this.state.driverIds.includes(driverInfoRow.driver_id) && (
                                  <Popconfirm
                                    placement="topRight"
                                    title={I18n.t("messages.confirm")}
                                    onConfirm={() =>
                                      this.handleDeleteDriverPayRow(orderIndex, index)
                                    }
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <Tooltip title={I18n.t("general.delete")}>
                                      <DeleteIcon dataTestId={`delete-driver-pay-icon-${index}`} className="textBold fontSize18" />
                                      &nbsp;&nbsp;
                                    </Tooltip>
                                  </Popconfirm>
                                )}
                                {!isDisabled &&
                                  orderDriverPayments[orderIndex].driver_payments
                                    .length -
                                    1 ===
                                    index &&
                                  !isEmpty(driverInfoRow.driver_id) &&
                                  !isEmpty(driverInfoRow.amount) && (
                                    <Icon
                                      data-testid={`add-driver-pay-icon-${index}`}
                                      type="plus-circle"
                                      onClick={() =>
                                        this.addDriverPayRow(orderIndex)
                                      }
                                      size="small"
                                      className="marginLeft10 fontSize18"
                                    />
                                  )}

                                </Col>
                              </Row>
                              </Col>
                            </Col>
                          </Row>
                        );
                      }
                    )}
                  </Fragment>
                ) : (
                  <Fragment>
                    <Alert
                      message={
                        <h4>
                          No Pickup Driver Payment Configuration is done for above
                          order.
                          <Button
                            type="link"
                            onClick={() => this.addDriverPayRow(orderIndex)}
                          >
                            Click here to configure
                          </Button>
                        </h4>
                      }
                      type="info"
                      showIcon
                      style={{ paddingBottom: 0, paddingTop: 2 }}
                    />
                  </Fragment>
                )}
    
              
              </Fragment>
            )
          )}
          </>
        )}
        <Row>
            <Col className="alignCenter">
              <Button
                data-testid="driver-pay-close-button"
                type="default"
                className="clearButtonStyle"
                onClick={this.handleClear}
                disabled={isDisabled}
                icon="close-circle"
              >
                {I18n.t("general.clear")}
              </Button>
              &nbsp;&nbsp;
              <Button
                data-testid="driver-pay-save-button"
                type="primary"
                onClick={this.handleSave}
                disabled={isDisabled}
                icon="save"
              >
                {I18n.t("general.save")}
              </Button>
            </Col>
          </Row>
            <Divider />

        {/* 
            Section 2: Driver Pay Configuration
            — collapsible per-order panels — */}
        {this.renderSectionHeader("Driver Pay Configuration")}

  {inProgress ? (
    <Skeleton active paragraph={{ rows: 6 }} />
  ) : (
    <>
      {this.state.currentInvoice.order_driver_details.map((order, orderIndex) => {
            const orderInfos = this.state.currentInvoice.orders_info?.filter(
              info => info.order_number === order.customer_order_number
            ) || [];

            const isTransferOrder = orderInfos.some(info => info.segment_type);
            
            let pickupLeg, deliveryLeg;
            if (isTransferOrder) {
              pickupLeg = orderInfos.find(info => info.segment_type === 'PICKUP');
              deliveryLeg = orderInfos.find(info => info.segment_type === 'DELIVERY');
            }

            const pickupLos = pickupLeg?.level_of_service;
            const deliveryLos = deliveryLeg?.level_of_service;

             const { orgRules } = this.props.userContext;

            const updateDriverRatesFromBilling = _.get(orgRules.org_billing_rules, 'consider_driver_rates_from_billing');
            const orderPickupAmount = this.state.driverAmounts.find((d) => d.segment === "PICKUP" && d.order_id === order.customer_order_id)?.amount || 0;
            const orderDeliveryAmount = this.state.driverAmounts.find((d) => d.segment === "DELIVERY" && d.order_id === order.customer_order_id)?.amount || 0;

            const driverIds = order.driver_details.map((driver) => driver.driver_id);
            const hasDuplicateDrivers = driverIds.length !== new Set(driverIds).size;
            const hasNullDriverRates = order?.driver_details?.some(driver => driver.driver_rates === null);

            let showSegregationCheckbox = false;
            let checkboxLabel = '';
            
            if (orderInfos.length > 0) {
              showSegregationCheckbox = isTransferOrder &&
                ((pickupLos === 'NONE' && deliveryLos !== 'NONE' && orderPickupAmount <= 0) ||
                  (deliveryLos === 'NONE' && pickupLos !== 'NONE' && orderDeliveryAmount <= 0)) && 
                (updateDriverRatesFromBilling === "true") && 
                !hasDuplicateDrivers && !hasNullDriverRates;
                
              if (pickupLos === 'NONE') {
                checkboxLabel = 'Segregate Delivery Driver pay between 2 drivers';
              } else if (deliveryLos === 'NONE') {
                checkboxLabel = 'Segregate Pickup Driver pay between 2 drivers';
              }
            } else {
              const hasPickupAmount = orderPickupAmount > 0;
              const hasDeliveryAmount = orderDeliveryAmount > 0;
              
              showSegregationCheckbox = (hasPickupAmount || hasDeliveryAmount) && 
                (updateDriverRatesFromBilling === "true") && 
                !hasDuplicateDrivers && !hasNullDriverRates;
                
              checkboxLabel = 'Segregate Driver pay between pickup and delivery';
            }
            const hasPickupAmount = this.state.driverAmounts.some(d => d.segment === 'PICKUP' && d.order_id === order.customer_order_id);
            const hasDeliveryAmount = this.state.driverAmounts.some(d => d.segment === 'DELIVERY' && d.order_id === order.customer_order_id);
            
            let showPickupAmount = false;
            let showDeliveryAmount = false;
            
            if (orderInfos.length > 0) {
              if (isTransferOrder) {
                showPickupAmount = hasPickupAmount;
                showDeliveryAmount = hasDeliveryAmount;
              } else {
                const orderInfo = orderInfos[0]; 
                if (orderInfo?.type_of_order === 'R') {
                  showPickupAmount = hasPickupAmount;
                } else if (orderInfo?.type_of_order === 'D') {
                  showDeliveryAmount = hasDeliveryAmount;
                }
              }
            } else {
              showPickupAmount = hasPickupAmount;
              showDeliveryAmount = hasDeliveryAmount;
            }

            const isSegregated = this.state.segregatedDriverPay[order.customer_order_number];

            // Find the matching transportation charge for this order (for DriverPayConfiguration)
            const matchingCharge = this.state.currentInvoice?.transportation_charges?.find(
              charge => charge.order_id === order.customer_order_id
            );

            return (
                <OrderCollapsiblePanel
                  key={`driverPayConfig${orderIndex}`}
                  orderNumber={order.customer_order_number}
                >
{(showPickupAmount || showDeliveryAmount) && (
  <div
    className="marginBottom10"
    style={{
      display: "flex",
      justifyContent: "flex-end",
      gap: 12,
      flexWrap: "wrap"
    }}
  >
          {showPickupAmount && (
              <span
                style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          background: "#eef2fa",
          border: "1px solid #d0daea",
          borderRadius: 6,
          padding: "4px 12px",
          fontSize: 13,
          fontWeight: 600,
          color: "#395484",
          whiteSpace: "nowrap"
        }}
      >
        {getOrderTypeIcon("R", { height: "24", width: "24" })}
        Pickup Driver Pay:
        {this.state.settlementProgress ? (
          <Spin size="small" style={{ marginLeft: 4 }} />
        ) : (
          <span>${orderPickupAmount.toFixed(2)}</span>
        )}
              </span>
          )}
          {showDeliveryAmount && (
              <span
                style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          background: "#eef2fa",
          border: "1px solid #d0daea",
          borderRadius: 6,
          padding: "4px 12px",
          fontSize: 13,
          fontWeight: 600,
          color: "#395484",
          whiteSpace: "nowrap"
        }}
      >
        {getOrderTypeIcon("D", { height: "24", width: "24" })}
        Delivery Driver Pay:
      {this.state.settlementProgress ? (
        <Spin size="small" style={{ marginLeft: 4 }} />
      ) : (
        <span>${orderDeliveryAmount.toFixed(2)}</span>
      )}
              </span>
          )}
        </div>
      )}

        {/* Segregation checkbox */}
                {showSegregationCheckbox && (
                  <Row className="marginTop10">
                    <Col xs={24}
                      style={{
                        fontStyle: "Regular",
                        fontWeight: "bold",
                        color: "#395484",
                      }}>
                      <Checkbox
                        checked={isSegregated}
                        onChange={(e) => this.handleSegregatedDriverPayChange(order.customer_order_number, e.target.checked)}
                      >
                        {checkboxLabel}
                      </Checkbox>
                    </Col>
                  </Row>
                )}

                {/* Segregation fields */}
                {isSegregated && showSegregationCheckbox && (
                  <Fragment>
                    {/* Payment Type */}
                    <Row className="marginTop10" align="middle" gutter={16} style={{
                        background: "#f7f9fc",
                        border: "1px solid #dce3ef",
                        borderRadius: 6,
                        padding: "10px 12px",
                        margin: "10px 0 0 0",
                      }}
                    >
                      <Col xs={4}>
                        <span style={{ fontWeight: "bold", fontSize: 13 }}>Payment Type:</span>
                      </Col>
                      <Col xs={1}> : </Col>
                      <Col xs={12}>
                        <Radio.Group
                          value={this.state.driverPayTypes[`${order.customer_order_number}_pickup`] || 'percentage'}
                          onChange={(e) => {
                            // Update both pickup and delivery types to the same value
                            this.handleDriverPayTypeChange(order.customer_order_number, 'pickup', e.target.value);
                            this.handleDriverPayTypeChange(order.customer_order_number, 'delivery', e.target.value);
                          }}
                        >
                          <Radio value="percentage">Percentage</Radio>
                          <Radio value="flat">Flat Amount</Radio>
                        </Radio.Group>
                      </Col>
                    </Row>

                    {/* Pickup pay row */}
                    <Row className="marginTop10" align="middle" gutter={16} style={{ paddingLeft: 12 }}>
                      <Col xs={4}>
                        <span style={{ fontWeight: 'bold', fontSize: 13 }}>Pickup Driver Pay:</span>
                      </Col>
                      <Col xs={1}> : </Col>
                      <Col xs={6}>
                        <Input
                          value={this.state.driverPayValues[`${order.customer_order_number}_pickup`] || ''}
                          onChange={(e) => this.handleDriverPayValueChange(order.customer_order_number, 'pickup', e.target.value)}
                          addonAfter={(!this.state.driverPayTypes[`${order.customer_order_number}_pickup`] || this.state.driverPayTypes[`${order.customer_order_number}_pickup`] === 'percentage') ? '%' : null}
                          addonBefore={this.state.driverPayTypes[`${order.customer_order_number}_pickup`] === 'flat' ? '$' : null}
                          style={{ width: '100%' }}
                        />
                      </Col>

                      {this.state.driverPayTypes[`${order.customer_order_number}_pickup`] !== 'flat' && (
                        <Col xs={6}>
                          <Input
                            disabled
                            readOnly
                            value={this.getCalculatedDriverPay(order.customer_order_number, 'pickup')}
                            addonBefore="$"
                            style={{ width: '100%' }}
                          />
                        </Col>
                      )}
                    </Row>

                    {/* Delivery pay row */}
                    <Row className="marginTop10" align="middle" gutter={16} style={{ paddingLeft: 12 }}>
                      <Col xs={4}>
                        <span style={{ fontWeight: 'bold', fontSize: 13 }}>Delivery Driver Pay:</span>
                      </Col>
                      <Col xs={1}> : </Col>
                      <Col xs={6}>
                        <Input
                          value={this.state.driverPayValues[`${order.customer_order_number}_delivery`] || ''}
                          onChange={(e) => this.handleDriverPayValueChange(order.customer_order_number, 'delivery', e.target.value)}
                          addonAfter={(!this.state.driverPayTypes[`${order.customer_order_number}_delivery`] || this.state.driverPayTypes[`${order.customer_order_number}_delivery`] === 'percentage') ? '%' : null}
                          addonBefore={this.state.driverPayTypes[`${order.customer_order_number}_delivery`] === 'flat' ? '$' : null}
                          style={{ width: '100%' }}
                        />
                      </Col>

                      {this.state.driverPayTypes[`${order.customer_order_number}_delivery`] !== 'flat' && (
                        <Col xs={6}>
                          <Input
                            disabled
                            readOnly
                            value={this.getCalculatedDriverPay(order.customer_order_number, 'delivery')}
                            addonBefore="$"
                            style={{ width: '100%' }}
                          />
                        </Col>
                      )}
                    </Row>

                    {/* Save Button */}
                    <Row className="marginTop10">
                      <Col span={24}>
                        <Button
                          icon="save"
                          type="primary"
                          style={{ float: "right" }}
                          onClick={() => this.handleSegregatedDriverPaySave(order.customer_order_id)}
                          loading={this.state.inProgress}
                        >
                          Save
                        </Button>
                      </Col>
                    </Row>

                  </Fragment>
                )}

                {/* DriverPayConfiguration per order */}
                {matchingCharge && (
                  
                    <DriverPayConfiguration
                      orderResponse={{
                        id: matchingCharge.order_id,
                        customer_order_details: {
                          type_of_order: matchingCharge.type_of_order || '',
                          organization_id: this.state.currentInvoice.account_details?.organization_id || userStore.getStateValue("selectedOrg"),
                          is_lh_order: matchingCharge.type_of_order === 'LH' || matchingCharge.type_of_order === 'LHD' || matchingCharge.type_of_order === 'PLH',
                        },
                        locations: matchingCharge.locations || [],
                      }}
                      activeKey="driverPayConfig"
                      isSegregated={isSegregated}
                      onConfigsLoaded={this.handleDriverPayConfigsLoaded}
                      orderIdentifier={order.customer_order_number}
                      callFrom="BILLING"
                      onConfigSaved={this.handleDriverPayConfigSaved}
                      isLocked={isLocked}
                    />
                  )}
                </OrderCollapsiblePanel>
              );
            })}
    </>
  )}


       <Divider /> 
          {/* Section 3: Driver Adjustments */}
        {this.renderSectionHeader("Driver Adjustments")}

          {this.state.adjProgress ? (
            <Skeleton active paragraph={{ rows: 4 }} />
          ) : (
            <>
              {orderDriverPayments.map((order, orderIndex) => {
            const locations = order.locations ||  []
            const transformedLocations = this.state.currentInvoice?.orders_info
            ?.filter(info => info.order_id === order.order_id)
            .map(info => ({
              order_type: info.segment_type === "PICKUP" ? "PICKUP" : "DELIVERY",
              location_id: info.locations?.[0]?.location_id,
              level_of_service_code: info.level_of_service,
              location_sequence: info.segment_type === "PICKUP" ? 0 : 1,
              loc_order_sequence: info.locations?.[0]?.location_sequence || ""
            })) || [];
          const orderDataWithLocations = {
            ...order,
            locations: transformedLocations,
            type_of_order: order.type_of_order || this.state.currentInvoice?.order_info?.type_of_order
          };
            return (
              <Fragment key={`driverAdjustments${orderIndex}`}>
                <Row>
                  <Col xs={12} className="alignLeft">
                    <span
                      style={{
                        fontSize: 14,
                        fontStyle: "italic",
                        fontWeight: "bold",
                        textDecoration: "underline",
                        color: "#395484",
                      }}
                    >
                      For Order #{order.order_no}
                    </span>
                   
                  </Col>
                </Row>
                {/* <DriverAdjustmentsTable
                    data={order.adjustments || []}
                    orderTypes={orderTypes}
                    glCodes={this.props.glCodesList}
                    onSave={this.onDriverPaySave}
                    loading={this.state.inProgress}
                    order={order}
                /> */}
                <DriverAdjustmentsTable
                  key={`adjustments-${order.order_id}-${this.state.driverAdjustments.length}`}
                  data={this.state.driverAdjustments.filter(adjustment => adjustment.customer_order_id === order.order_id).map(adjustment => ({
                    key: adjustment.id,
                    description: adjustment.driver_adjustments?.description || '',
                    location_id: adjustment.driver_adjustments?.location_id || 
                    (locations?.length == 1 ? locations[0].location_id : ''), // Map correctly
                    glCode: adjustment.driver_adjustments?.gl_code || '',
                    amount: adjustment.driver_adjustments?.amount,
                    amount_type: adjustment.driver_adjustments?.amount_type || 'FLAT_PAY'
                  }))}
                  orders_info={this.state.currentInvoice.orders_info}
                  locations={locations}
                  glCodes={this.props.glCodesList}
                  onSave={this.onDriverPaySave}
                  onDelete={this.onDriverPayDelete}
                  loading={this.state.adjProgress}
                  order={order}
                  orderDataWithLocations={orderDataWithLocations}
                />
               
              </Fragment>
            );
          })}
            </>
          )}
     <Divider />

        {/* Section 4: Driver Settlements */}
    {driverRateSheetEnabled !== 'true' && (
      <>
        {this.state.settlementProgress ? (
          <Skeleton active paragraph={{ rows: 4 }} />
        ) : (
          <>
            {orderDriverPayments.map((order, orderIndex) => {
            // Get all settlements for this order
            const settlementsForOrder = this.state.driverSettlements?.filter(settlement => settlement.customer_order_id === order.order_id) || [];

            if (settlementsForOrder.length === 0) {
              return null;
            }

            return (
              <Fragment key={`driverSettlements${orderIndex}`}>
                      {orderIndex === 0 && this.renderSectionHeader("Driver Settlements")}
                <Row>
                  <Col xs={12} className="alignLeft">
                    <span
                      style={{
                        fontSize: 14,
                        fontStyle: "italic",
                        fontWeight: "bold",
                        textDecoration: "underline",
                        color: "#395484",
                      }}
                    >
                      For Order #{order.order_no}
                    </span>
                  </Col>
                </Row>
                {settlementsForOrder.map((settlement, idx) => {
                  const hasDailySettlements = driverSettlementsBy === "daily" && settlement?.driver_pay_invoice_lines?.length > 0;
                  const hasWeeklySettlements = driverSettlementsBy === "weekly" && settlement;

                  if (!hasDailySettlements && !hasWeeklySettlements) {
                    return null;
                  }

                  return (
                    <Fragment key={settlement.id || idx}>
                      <Row>
                        <Col xs={24} className="alignLeft">
                          <Text strong>
                            {settlement?.segment_type?.toUpperCase() || ""}
    </Text>
    {settlement?.driver_code && (
      <Text strong style={{ marginLeft: 8 }}>
        | Driver: {settlement.driver_code}
      </Text>
    )}
                  </Col>
                </Row>
                {driverSettlementsBy === "daily" && hasDailySettlements && 
                  <DriverDailySettlements
                    data={settlement.driver_pay_invoice_lines}
                    onChange={this.handleSettlementsChange}
                    handleSave={this.handleDailySettlementSave}
                    status={settlement.status}
                  />
                }
                {driverSettlementsBy === "weekly" && hasWeeklySettlements && (
                  <DriverWeeklySettlements
                    data={this.state.driverSettlements.filter(settlement => settlement.customer_order_id === order.order_id)}
                    handleSave={this.handleWeeklySettlementSave}
                  />
                    )}
               </Fragment>
             );
          })}
              </Fragment>
            );
          })}
          </>
        )}
      </>
    )}
      </div>
    );
    
  }
}

export default BillingDriverPay;